module.exports = __webpack_public_path__ + "img/py_list_qwfb_seleted.1769873d.png";